import type { TruthfulStateKind } from './SurfaceState.types';

type QueryObservation = {
  status: 'pending' | 'error' | 'success';
  fetchStatus: 'fetching' | 'paused' | 'idle';
  /** Only the caller can establish that a complete response contains no records. */
  result: 'missing' | 'empty' | 'present';
  permissionDenied?: boolean;
  partial?: boolean;
  stale?: boolean;
};

/** Precedence prevents cached/absent/partial data being described as verified empty. */
export function surfaceQueryState(query: QueryObservation): TruthfulStateKind | 'ready' {
  if (query.permissionDenied) return 'permission';
  if (query.status === 'error') {
    if (query.fetchStatus === 'fetching') return 'retrying';
    return query.result === 'present' ? 'stale' : 'unavailable';
  }
  if (query.status === 'pending') {
    if (query.fetchStatus === 'paused') return 'unavailable';
    // pending + idle = a disabled query (enabled: false) that has never run.
    // Nothing is loading and nothing was checked: it is waiting for input.
    return query.fetchStatus === 'idle' ? 'idle' : 'loading';
  }
  if (query.result === 'missing') return 'unavailable';
  if (query.partial) return 'partial';
  if (query.stale) return 'stale';
  return query.result === 'empty' ? 'verified-empty' : 'ready';
}
